import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold" }, "Выбор аккаунта", -1)
const _hoisted_2 = { class: "-mx-2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Добавить аккаунт ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-black/3 my-2" }, null, -1)
const _hoisted_5 = { class: "text-xs text-gray-400" }


import { useVModel } from "@vueuse/core";

import { useStore } from "@/use/useStore";
import { TUserWithSchool } from "@/types/user";

import UiIcon from "./ui/UiIcon.vue";
import UiModalPage from "./ui/UiModalPage.vue";
import UiModalPageHeader from "./ui/UiModalPageHeader.vue";
import UiModalPageHeaderClose from "./ui/UiModalPageHeaderClose.vue";
import UiSimpleCell from "./ui/UiSimpleCell.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountSelectModal',
  props: {
  modelValue: Boolean,
},
  setup(__props) {

const props = __props



const { users, currentUser, setCurrentUser } = useStore();

const show = useVModel(props, "modelValue");

function onSelectUser(user: TUserWithSchool) {
  setCurrentUser(user);
  show.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(UiModalPage, {
    modelValue: _unref(show),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(show) ? (show).value = $event : null))
  }, {
    header: _withCtx(() => [
      _createVNode(UiModalPageHeader, null, {
        before: _withCtx(() => [
          _createVNode(UiModalPageHeaderClose, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = false))
          })
        ]),
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/accounts",
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createVNode(UiSimpleCell, {
              onClick: ($event: any) => (navigate())
            }, {
              before: _withCtx(() => [
                _createVNode(UiIcon, {
                  type: "solid",
                  icon: "Plus"
                })
              ]),
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(users), (user) => {
          return (_openBlock(), _createBlock(UiSimpleCell, {
            onClick: ($event: any) => (onSelectUser(user)),
            active: user.id === _unref(currentUser)?.id,
            key: user.id
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(user.surname) + " " + _toDisplayString(user.name) + " " + _toDisplayString(user.description), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(user.school?.full_name), 1)
            ]),
            after: _withCtx(() => [
              (user.id === _unref(currentUser)?.id)
                ? (_openBlock(), _createBlock(UiIcon, {
                    key: 0,
                    type: "solid",
                    icon: "CheckCircle",
                    class: "text-blue-500"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["onClick", "active"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})